export default __webpack_public_path__ + "static/media/picnic.7877a23d.svg";